<template>
  <div>
    <h3>
      Categories
      <span v-text="`(${selectedCategoryUuids.length})`" />
    </h3>
    <div class="flex justify-center items-baseline mt-4">
      <div class="input-group flex-1">
        <input
          v-model="search"
          type="text"
          class="recipientFilter"
          placeholder="Filter categories"
        >
      </div>
      <div class="text-xs pl-4">
        <a
          href="#"
          @click.prevent="selectAll"
          v-text="'Select All'"
        />
        <span
          class="mx-2"
          v-text="'|'"
        />
        <a
          href="#"
          @click.prevent="selectNone"
          v-text="'Select None'"
        />
      </div>
    </div>
    <ul
      v-if="filteredCategories.length"
      class="scroll-checklist scroll-blue"
    >
      <li
        v-for="category in filteredCategories"
        :key="category.uuid"
      >
        <input
          :id="category.uuid"
          v-model="selectedCategories"
          type="checkbox"
          :name="category.uuid"
          :value="category.uuid"
        >
        <label
          :for="category.uuid"
          class="checkbox"
          v-text="category.attributes.title"
        />
      </li>
    </ul>
    <ul
      v-else
      class="list-reset"
    >
      <li>
        <small>No results for "{{ search }}"</small>
      </li>
    </ul>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'BlogCategorySelector',
  model: {
    prop: 'selectedCategoryUuids',
  },
  props: {
    selectedCategoryUuids: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCategories: [],
      search: '',
    }
  },
  computed: {
    filteredCategories() {
      if (this.categories.length) {
        return this.categories.filter((category) => {
          return category.attributes.title.toLowerCase().includes(this.search.toLowerCase())
        })
      }

      return []
    },
    categories() {
      return this.$store.state.communication.categories.data
    },
  },
  watch: {
    selectedCategoryUuids(newVal) {
      if (newVal !== this.selectedCategories) {
        this.selectedCategories = newVal
      }
    },
    selectedCategories() {
      this.$emit('input', this.selectedCategories)
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.selectedCategories = this.selectedCategoryUuids

      this.$store.dispatch('communicationGetCategories')
    })
  },
  methods: {
    selectAll() {
      this.selectedCategories = _.map(this.categories, 'uuid')
    },
    selectNone() {
      this.selectedCategories = []
    },
  },
}
</script>

<style>
.recipientFilter {
  margin-bottom: 0 !important;
}
</style>
